import { LinkDefination } from '../../../components';
import { ContentCardCarouselProps } from '../../../components/ContentCardCarousel/types/propsTypes';
import { CMSTransformerDataType } from '../../types/common';

const transformContentCardCarousel = (data: CMSTransformerDataType): ContentCardCarouselProps => {
  const keys = Object.keys(data ?? {});
  const contentCardCarousal = Array.isArray(data?.[keys[0]]) ? data?.[keys[0]][0] : data?.[keys[0]];

  const viewAllLink: LinkDefination = {
    text: contentCardCarousal?.link?.text,
    url: contentCardCarousal?.link?.url,
    target: contentCardCarousal?.link?.target,
  };
  const title = contentCardCarousal?.display_title;
  const contentCardCarouselData: CMSTransformerDataType = contentCardCarousal?.cards;

  return {
    componentType: keys[0],
    contentCardCarouselData: contentCardCarouselData,
    link: viewAllLink,
    title,
  };
};

export default transformContentCardCarousel;
